export default __webpack_public_path__ + "static/media/gear.8b6c44c135bcd022c98699de0ecdbb7c.svg";